import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-345d56a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home-investment",
  id: "investment"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-6\" data-aos=\"fade-right\" data-aos-duration=\"1000\" data-v-345d56a6><div class=\"invest-content\" data-v-345d56a6><span class=\"section-tag\" data-v-345d56a6><i class=\"ri-funds-line\" data-v-345d56a6></i> Franchise Opportunity </span><h2 data-v-345d56a6>Franchise <span class=\"text-accent\" data-v-345d56a6>Investment</span> Overview</h2><p class=\"lead-text\" data-v-345d56a6> The franchise fee is competitively set at $50,000 with a 10-year term, making this opportunity accessible for a premium quick-service halal Mexican restaurant brand. </p><p class=\"sub-text\" data-v-345d56a6> The halal food market is growing at a 9% CAGR through 2029. Combined with strong demand in the NYC metro area, Guac &amp; Grill is positioned to capture a promising niche with low competition and high consumer demand. </p><div class=\"invest-highlights\" data-v-345d56a6><div class=\"highlight-item\" data-v-345d56a6><div class=\"highlight-num\" data-v-345d56a6>9<span data-v-345d56a6>%</span></div><p data-v-345d56a6>CAGR halal food<br data-v-345d56a6>market growth</p></div><div class=\"highlight-item\" data-v-345d56a6><div class=\"highlight-num\" data-v-345d56a6>1.39<span data-v-345d56a6>M</span></div><p data-v-345d56a6>Residents in<br data-v-345d56a6>target market</p></div><div class=\"highlight-item\" data-v-345d56a6><div class=\"highlight-num\" data-v-345d56a6>$143<span data-v-345d56a6>K</span></div><p data-v-345d56a6>Median household<br data-v-345d56a6>income</p></div></div></div></div>", 1)
const _hoisted_5 = {
  class: "col-lg-6",
  "data-aos": "fade-left",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_6 = { class: "fee-cards" }
const _hoisted_7 = ["data-aos-delay"]
const _hoisted_8 = { class: "fee-icon" }
const _hoisted_9 = { class: "fee-info" }
const _hoisted_10 = { class: "fee-label" }
const _hoisted_11 = { class: "fee-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-send-plane-line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feeItems, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.label,
                class: "fee-card",
                "data-aos": "fade-up",
                "data-aos-delay": 300 + index * 100
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass(item.icon)
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.value), 1)
                ])
              ], 8, _hoisted_7))
            }), 128)),
            _createElementVNode("a", {
              href: "#contact",
              class: "btn-apply-franchise",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollToForm && _ctx.scrollToForm(...args)), ["prevent"]))
            }, [
              _hoisted_12,
              _createTextVNode(" Apply for Franchise ")
            ])
          ])
        ])
      ])
    ])
  ]))
}